export default {
  keys: {
    entry: '_mc_entry',
    user: '_mc_user',
    menu: '_mc_menu',
    wordbooks: '_mc_wordbooks',
    instList: '_mc_instList', //平台列表
    productList: '_mc_productList', //平台产品列表
    creditorList: '_mc_creditorList', //资方列表
    creditorProductList: '_mc_creditorProductList', //资方列表
    btnPermission: '_mc_btnPermission', // 权限按钮
    platformNo: '_mc_platformNo' // 平台机构号
  },
  common: {
    captcha: '/loanadmin/captcha.jpg?key=', // 图形验证码
    upload: '/loanadmin/sys/oss/upload', // 上传
    wordbooks: '/loanadmin/sys/dict/listallgroup', // 数据字典配置
    instSelectAll: '/loanadmin/sys/inst/listselectall', // 机构下拉框--全部
    instSelectCur: '/loanadmin/sys/inst/listselect', // 机构下拉框--当前用户
    productSelect: '/loanadmin/product/productplatform/listselectall', // 产品下拉(根据平台编号)
    productSelectLimit: '/loanadmin/product/productplatform/listselectlimit', // 产品下拉(有条件限制的:platformInstNo  平台机构号 customerNo 客户编号)
    creditorSelectAll: '/loanadmin/base/baseinstcreditor/listselectall', // 机构资方下拉框
    creditorSelect: '/loanadmin/product/productcreditor/listselectall', // 资方产品拉框
    verificationCode: '/loanadmin/checksms', //校验验证码
    listselectconfig: '/loanadmin/product/productplatform/listselectconfig', //获取选择已配置申请材料的产品
    dictListgroup: 'loanadmin/sys/dict/listgroup', //依赖材料
    interfaceLogList: '/loanadmin/api/apilog/list', //接口日志
    systemLogList: '/loanadmin/sys/log/list', //系统日志
    basememberList: '/loanadmin/base/basemember/listselectall ', //会员客户下拉列表
    getCaptchaSmsCode: '/loanadmin/getSmsCode', //短信验证码（需要图形验证码）
  },
  dictionary: {
    list: '/loanadmin/sys/dict/list', // 数据字典列表
    create: '/loanadmin/sys/dict/save', // 添加字典
    update: '/loanadmin/sys/dict/update', // 更新字典
    delete: '/loanadmin/sys/dict/delete' // 删除字典
  },
  user: {
    login: '/loanadmin/sys/login', // 后台登录
    logout: '/loanadmin/logout', // 后台退出登录
    info: '/loanadmin/sys/user/info', // 后台获取用户信息
    list: '/loanadmin/sys/user/list', // 用户列表
    create: '/loanadmin/sys/user/save', // 添加用户
    update: '/loanadmin/sys/user/update', // 更新用户
    delete: '/loanadmin/sys/user/delete', // 删除用户
    selectRole: '/loanadmin/sys/role/select', // 选择角色
    initMenu: '/loanadmin/sys/menu/nav', // 当前用户菜单列表
    memberList: '/loanadmin/base/basemember/list', // 会员管理-会员列表
    memberInfo: '/loanadmin/base/basemember/info/', // 会员管理-会员详情
    certifyMember: '/loanadmin/base/basemember/checklist', // 认证管理-待审核列表
    certifyList: '/loanadmin/base/baseverifi/list', // 认证管理-列表
    certifyCheck: '/loanadmin/base/basemember/check', // 认证管理-审核
    certifyDetail: '/loanadmin/base/basemember/checkinfo/', // 认证管理-详情:id
    getBankList: '/loanadmin/base/baseaccount/list', // 获取绑定的银行卡
    saveBankList: '/loanadmin/base/baseaccount/save', // 绑定银行卡
    defaultBankList: '/loanadmin/base/baseaccount/setdefault', // 设为默认
    delBankList: '/loanadmin/base/baseaccount/delete', // 解绑银行卡
    verificationBank: '/loanadmin/mc/public/getaccountinfo', //获取打款验证信息
    bankPaymentList: '/loanadmin/base/baseaccount/list', //后台打款验证列表
    hadPayment: '/loanadmin/base/baseaccount/confirmpayment', //我已打款
    checkPayment: '/loanadmin/base/baseaccount/check', //后台打款验证审核
    updatePasswd: '/loanadmin/sys/user/updatepassword', //修改登录密码
    updateMobile: '/loanadmin/sys/user/updatemobile', //修改手机号
    updateEmail: '/loanadmin/sys/user/updateemail', //修改邮箱,
    getusermenuperms: '/loanadmin/sys/menu/getusermenuperms', //获取用户按钮权限,
    initMenuAll: '/loanadmin/sys/menu/navall' // 带按钮的菜单
  },
  member: {
    login: '/loanadmin/member/login', // 前台用户登录
    register: '/loanadmin/base/basemember/register', // 前台用户注册
    getcode: '/loanadmin/captchasms', // 前台用户注册获取短信验证码
    info: '/loanadmin/base/basemember/info', // 前台获取用户信息
    certify: '/loanadmin/base/basemember/certify' // 前台用户个人/企业认证
  },
  permission: {
    roleList: '/loanadmin/sys/role/list', // 角色列表
    roleCreate: '/loanadmin/sys/role/save', // 添加角色
    roleUpdate: '/loanadmin/sys/role/update', // 更新角色
    roleDelete: '/loanadmin/sys/role/delete', // 删除角色
    menuSelect: '/loanadmin/sys/menu/select', // 所有菜单选择
    menuListAll: '/loanadmin/sys/menu/listall', // 菜单列表:parentId
    menuCreate: '/loanadmin/sys/menu/save', // 添加菜单
    menuUpdate: '/loanadmin/sys/menu/update', // 更新菜单
    menuDelete: '/loanadmin/sys/menu/delete' // 删除菜单
  },
  agency: {
    list: '/loanadmin/sys/inst/list', // 机构列表
    detail: '/loanadmin/sys/inst/info', // 机构详情:id
    create: '/loanadmin/sys/inst/save', // 添加机构
    update: '/loanadmin/sys/inst/update', // 修改机构
    delete: '/loanadmin/sys/inst/delete', // 删除机构
    parentAgency: '/loanadmin/sys/inst/listselectall',
    saveInterfaceKey: '/loanadmin/sys/inst/setsecret' //设置接口秘钥
  },
  product: {
    list: '/loanadmin/product/productplatform/list', // 产品列表
    detail: '/loanadmin/product/productplatform/info', // 产品详情:id
    create: '/loanadmin/product/productplatform/save', // 添加产品
    update: '/loanadmin/product/productplatform/update', // 修改产品
    delete: '/loanadmin/product/productplatform/delete', // 删除产品
    funcList: '/loanadmin/product/productfunctionconfig/list', // 产品功能配置列表
    funcCreate: '/loanadmin/product/productfunctionconfig/save', // 产品功能配置添加
    funcUpdate: '/loanadmin/product/productfunctionconfig/update', // 产品功能配置修改
    mateList: '/loanadmin/product/productmaterialconfig/list', // 产品材料配置列表
    mateCreate: '/loanadmin/product/productmaterialconfig/save', // 产品材料配置添加
    mateUpdate: '/loanadmin/product/productmaterialconfig/update', // 产品材料配置修改
    creditorList: '/loanadmin/product/productcreditor/list', // 产品资方列表，参数productCode
    creditorSave: '/loanadmin/product/productcreditor/save', // 产品资方保存
    creditorUpdate: '/loanadmin/product/productcreditor/update', // 产品资方修改
    materialSave: '/loanadmin/product/productmateriallist/savebatch', // 资方配置材料
    materialList: '/loanadmin/product/productmateriallist/list', // 资方配置列表，参数productCode
    deleteCreditor: '/loanadmin/product/productcreditor/delete', // 资方删除产品
    logicdeleteCreditor: '/loanadmin/product/productcreditor/logicdelete', // 逻辑删除资方产品
    productmateriallist: '/loanadmin/product/productmateriallist/list', // 产品材料列表
    managementSummary: '/loanadmin/sys/inst/infocreditor/', // 资方概要:id
    getCapitalProducts: '/loanadmin/product/productcreditor/list', // 资方产品列表查询
    getCapitalProductInfo: '/loanadmin/product/productcreditor/info/', // 资方产品详情查询
    saveCapitalProducts: '/loanadmin/product/productcreditor/save', // 资方新增产品
    getCreditorInfo: '/loanadmin/base/baseinstcreditor/info', //平台详情查询资金方概要
    creditorlistselectlimit:
      '/loanadmin/product/productcreditor/listselectlimit', // 支用页面查询资方 platformInstNo productCode customerNo
    delMaterial: '/loanadmin/product/productmateriallist/delete', //删除资方配置材料
    getInterest: '/loanadmin/product/productcreditorinterest/list', //查询利息
    saveInterest: '/loanadmin/product/productcreditorinterest/save', //保存利息
    delInterest: '/loanadmin/product/productcreditorinterest/delete', //删除利息
    getPlatformList: '/loanadmin/product/productplatform/listselectnotexist', //新增平台产品 , 下拉列表接口
    savePlatformProduct: '/loanadmin/product/productcreditor/addproduct', //资方新增平台产品
    delPlatformProduct: '/loanadmin/product/productplatform/removeproduct', //资方详情删除平台产品
    platformProductList: '/loanadmin/product/productplatform/listproduct', //资方详情获取平台产品列表
    getCreditorList: '/loanadmin/product/productcreditor/listselectnotexist', //新增资方产品 , 下拉列表接口
    saveCreditorProduct: '/loanadmin/product/productplatform/addproduct', //平台新增资方产品
    delCreditorProduct: '/loanadmin/product/productcreditor/removeproduct', //平台详情删除平台产品
    creditorProductList: '/loanadmin/product/productcreditor/listproduct', //平台详情获取资方产品列表
    verifyCreditorProduct: '/loanadmin/product/productcreditor/check', // 资方产品审核平台
    verifyPlatformProduct: '/loanadmin/product/productplatform/check', // 平台产品审核资方
    listproductplatform: '/loanadmin/product/productplatform/listproductplatform'
  },
  loan: {
    // loancreditlimit: '/loanadmin/loan/loancreditlimit/apply',           // 授信申请
    loancreditlimitApply: '/loanadmin/loan/loancreditlimit/apply', // 授信申请
    loancreditlimitList: '/loanadmin/loan/loancreditlimit/list', // 授信申请列表
    loancreditlimit: '/loanadmin/loan/loancreditlimit/list', // 授信额度列表
    loancreditlimitCheck: '/loanadmin/loan/loancreditlimit/check', // 授信申请审核
    loanorderList: '/loanadmin/loan/loanorder/list', // 借款查询
    loanorderInfo: '/loanadmin/loan/loanorder/info', // 借款详情
    // loancreditlimitInfo: '/loanadmin/loan/loancreditlimit/info',     // 获取授信额度信息
    loanorderapply: '/loanadmin/loan/loanorder/apply', // 支用申请
    loanorderapplyCheck: '/loanadmin/loan/loanorder/check', // 支用审核
    loanorderlendList: '/loanadmin/loan/loanorderlend/list', // 放款列表
    // loanorderrepaySave: '/loanadmin/loan/loanorderrepay/save',       // 还款
    loanorderrepayInfo: '/loanadmin/loan/loanorderrepay/info', // 还款详情
    loanorderrepayList: '/loanadmin/loan/loanorderrepay/list', // 还款管理列表
    loancreditlimitInfo: '/loanadmin/loan/loancreditlimit/info', // 授信申请详情
    loanorderrepayConfirm: '/loanadmin/loan/loanorderrepay/confirm', // 确认还款
    loancreditraiseSave: '/loanadmin/loan/loancreditraise/save', // 申请提额操作
    loancreditraiseList: '/loanadmin/loan/loancreditraise/list', // 申请提额列表
    loancreditraiseCheck: '/loanadmin/loan/loancreditraise/check', // 申请提额审核
    loancreditdelaySave: '/loanadmin/loan/loancreditdelay/save', // 申请延期操作
    loancreditdelayList: '/loanadmin/loan/loancreditdelay/list', // 申请延期列表
    loancreditdelayCheck: '/loanadmin/loan/loancreditdelay/check', // 申请延期审核
    listselectallorlimit:
      'loanadmin/product/productcreditor/listselectallorlimit', //申请贷款查资方(包含额度...)
    loancreditcheckapply: 'loanadmin/loan/loancreditapply_old/checkapply', //校验是否可以申请额度
    checkrepay: 'loanadmin/loan/loanorderrepay/checkrepay', //校验是否可以还款
    loanorderlendSave: 'loanadmin/loan/loanorderlend/save', //放款
    computerepay: '/loanadmin/loan/loanorderrepay/computerepay', //还款试算
    commitrepay: '/loanadmin/loan/loanorderrepay/commitrepay', //还款提交
    supplierList: 'loanadmin/mall/mallordersum/list', //供应商授信列表
    freezelimit: 'loanadmin/loan/loancreditlimit/freezelimit/', //冻结额度

    loanrecordList: 'loanadmin/loan/loanrecord/list', //查询供应商贷款记录
    loanrecordCheckUpdate: 'loanadmin/loan/loanrecord/checkUpdate', //审核供应商申请贷款记录
    loanrecordCheckState: 'loanadmin/loan/loanrecord/checkState', //审核供应商借款状态
    loanrecordinfo: 'loanadmin/loan/loanrecord/info/', //根据ID查询供应商贷款详情
    getRequestedCustomerList: 'loanadmin/loan/loanrecord/getRequestedCustomerList', //根据机构号查询已申请客户


    // loanorderpaySave: '/loanadmin/loan/loanorderpay/save',              // 放款
    loanorderrepaySave: '/loanadmin/loan/loanorderrepay/save', // 还款
    gradeList: 'loanadmin/credit/creditrating/list', //信用评价列表
    saveGrade: 'loanadmin/credit/creditrating/rating', //评级
    saveSupplier: 'loanadmin/mall/mallordersum/credit', //授信
    saveDistribute: 'loanadmin/mall/mallordersum/setcreditor', //分配资方
    loannotice: 'loanadmin/loan/loannotice/list',             //贷款须知
    loannoticeSave: 'loanadmin/loan/loannotice/save',         //保存贷款须知
    loannoticeUpdate: 'loanadmin/loan/loannotice/update',     //修改贷款须知
    loannoticeDelete: 'loanadmin/loan/loannotice/delete',     //删除贷款须知
    calculateLoanByWeb: 'loanadmin/loan/financingInfo/calculateLoanByWeb',  //融资计划
  },
  sign: {
    signInfo: '/loanadmin/base/basecomsign/info', // 签章信息
    signSave: '/loanadmin/base/basecomsign/save', //签章认证
    signUpdata: '/loanadmin/base/basecomsign/update', //签章重新认证
    signList: '/loanadmin/base/basecomsign/list', //后台表格
    signCheck: '/loanadmin/base/basecomsign/check', //审核
    signAuthorization: '/loanadmin/base/basecomsignauthorize/list', //授权列表
    signUser: '/loanadmin/sys/user/listselect', //被授权人
    signSaveAuthorization: '/loanadmin/base/basecomsignauthorize/save', //授权
    signDeleteAuthorization: '/loanadmin/base/basecomsignauthorize/delete', //取消授权
    signLog: '/loanadmin/base/basecomsignlog/list' //签章日志
  },
  notice: {
    noticeLog: '/loanadmin/sms/smslog/list', //短信日志
    noticeSign: '/loanadmin/sms/smssign/list', //签名列表
    noticeDel: '/loanadmin/sms/smssign/delete', //签名删除
    noticeUpdate: '/loanadmin/sms/smssign/update', //签名修改
    noticeSave: '/loanadmin/sms/smssign/save', //签名新增
    noticeModelList: '/loanadmin/sms/smstemplate/list', //模板列表
    noticeModelDel: '/loanadmin/sms/smstemplate/delete', //模板删除
    noticeModelUpdate: '/loanadmin/sms/smstemplate/update', //模板修改
    noticeModelSave: '/loanadmin/sms/smstemplate/save' //模板新增
  },
  receipt: {
    list: '/loanadmin/warehouse/warehouseloanapply/list', //列表
    detail: '/loanadmin/warehouse/warehouseloandetail/getListBySeriesNumber', //物料详情
    check: '/loanadmin/warehouse/warehouseloanapply/check' //
  },
  open:{
    openList: '/loanadmin/base/baseapplyopen/list', // 平台开通金融申请列表
    openCheck: '/loanadmin/base/baseapplyopen/check' // 平台开通金融申请审核

  },
  factoring:{
    loanapplylist: '/loanadmin/factoring/factoringloanapply/list',  //保理申请列表
    getDetailBySeriesNumber: '/loanadmin/factoring/factoringloandetail/getDetailBySeriesNumber',  //保理申请详情
    loanApplyCheck: '/loanadmin/factoring/factoringloanapply/check',  //保理申请审核

    supplier2finance: '/loanadmin/supplier2finance/list', //查询保理贷申请客户
    getByStoreIdPurchaserList: '/loanadmin/supplier2finance/getByStoreIdPurchaserList', //根据供应商ID查询申请订单的采购商列表
    supplier2financeUpdate: '/loanadmin/supplier2finance/update',                       //供应商信息审核
    purchaser2financeUpdate: '/loanadmin/purchaser/purchaser2finance/update', //采购商信息审核
    supplierfileInfo: '/loanadmin/supplier/supplierfile/info/', //查询供应商资料
    supplier2purchaserfile: '/loanadmin/supplier2purchaser/supplier2purchaserfile/list', //查询采购商资料

  },
  level:{
    getLevelTypeList: '/loanadmin/level/levelType/list', //查询信用等级
    saveLevelType: '/loanadmin/level/levelType/save', //保存信用等级
    updateLevelType: '/loanadmin/level/levelType/update', //修改信用等级
    deleteLevelType: '/loanadmin/level/levelType/delete', //删除信用等级
    getPurchaserLevel: '/loanadmin/level/levelType/getPurchaserLevel', //获取采购商等级列表
    getSupplierLevel: '/loanadmin/level/levelType/getSupplierLevel', //获取供应商等级列表
    purchaserUpdate: '/loanadmin/purchaser/purchaser/update', //修改采购商等级
    supplierUpdate: '/loanadmin/supplier2finance/updateSupplierLevel', //修改供应商等级
    purchaserhislevel: '/loanadmin/purchaser/purchaserhislevel/list', //采购商历史等级记录
    supplierhislevel: '/loanadmin/supplier/supplierhislevel/list', //供应商历史等级记录

  },
  repay:{
    repayrecordList: '/loanadmin/repay/repayrecord/list', //根据贷款ID查询供应商还款详情
    repayrecordUpdate: '/loanadmin/repay/repayrecord/update', //审核供应商还款记录
    loanrecordInfo: '/loanadmin/loan/loanrecord/info/', //贷款信息
  }
}
